import ImportProducts from './ImportProducts'

/* import compose from 'recompose/compose'
import withState from 'recompose/withState'

import withUploadFile from './withUploadFile'

export default compose(
  withState('templateName', 'setTemplateName', ''),
  withState('file', 'setFile', null),
  withUploadFile
)(Upload) */
module.exports = ImportProducts



// WEBPACK FOOTER //
// ./src/components/ImportProducts/index.js